<template>
    <div class="order-status-form">
        <p>Arena'ya vermiş olduğunuz siparişin durumunu gerçek zamanda takip edebilirsiniz.</p>
        <b-overlay :show="isLoading" opacity="0.5">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(handleQuery)">
                    <validation-provider
                    name="query"
                    :rules="{ required: true, min: 3 }"
                    v-slot="validationContext"
                    >
                        <b-form-group
                            id="fieldset-1"
                            description="Sorgulamak istediğiniz sipariş numarasını girin."
                            label="Sipariş Numarası"
                            label-for="orderQueryTxt"
                        >                  
                            <b-input-group >
                                <b-form-input 
                                    ref="orderQueryTxt" 
                                    id="orderQueryTxt" 
                                    v-model="query" 
                                    trim  
                                    :state="getValidationState(validationContext)"
                                    autocomplete="off"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="info" @click="resetQuery"><v-icon name="times" /></b-button>
                                    <b-button type="submit" variant="info" ><v-icon name="search" /></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </validation-provider>
                </b-form>
            </validation-observer>
        </b-overlay>
    </div>
</template>

<script>
    export default {
        name: 'OrderStatusForm',
        data() {
            return {
                uriAfterSales: process.env.VUE_APP_URI_ARENA_API_AFTERSALES,
                isLoading: false,
                query: ''
            }
        },
        methods: {
            async handleQuery() {
                this.isLoading = true;
                this.$emit('QueryResponse', null);
                this.$emit('QueryRequest', { from: 'OrderStatusForm', query: this.query, icon: 'shipping-fast', tabIndex: 2 });
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('OrderStatusForm');
                fetch(`${this.uriAfterSales}/OrderStatus?recaptchaToken=${token}&orderId=${this.query}`)
                .then(res => { return res.json(); })
                .then(data => {
                    this.$emit('QueryResponse', data);
                    this.isLoading = false;
                });
            },
            resetQuery() {
                this.query = '';
                this.$emit('QueryResponse', null);
                this.$nextTick(() => {
                    this.$refs.observer.reset();
                });
            },
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            }
        }
    }
</script>

<style scoped>

</style>